module.exports = __webpack_public_path__ + "static/media/yokohama_minatoc031a5ef5500d8f6f9fc18cd2631d168.webp";